import React from 'react';
import PropTypes from 'prop-types';
import {
  Select, FormControl, InputLabel,
} from '@material-ui/core';
import { PauseTypography } from '../PauseTypography';
import { ChevronDown } from '../../../assets/icons/feather/components';
import { PauseMenuItem } from '../PauseMenuItem';

export const PauseSelect = ({
  id = 'select', label, options = [], ...props
}) => (
  <FormControl
    {...props}
    css={(theme) => ({
      width: '100%',
      minWidth: '120px',
      borderRadius: theme.spacing(0.5),
      '& .MuiFilledInput-root': {
        borderRadius: theme.spacing(0.5),
        color: theme.get('palette.pause.primary.dark'),
      },
      '& .MuiSelect-root': {
        borderRadius: theme.spacing(0.5),
      },
      '& .MuiFilledInput-root:not(.Mui-disabled)': {
        backgroundColor: theme.get('palette.pause.background.light'),
        '&:hover': {
          backgroundColor: theme.get('palette.pause.background.medium'),
        },
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: theme.get('palette.pause.background.dark'),
      },
      '& .MuiFilledInput-underline:after, & .MuiFilledInput-underline:before': {
        content: 'none',
      },
      '& .MuiFormLabel-root:not(.Mui-error)': {
        color: theme.get('palette.pause.primary.medium'),
      },
      '& .MuiFormLabel-root.Mui-Error': {
        color: theme.get('palette.pause.error.main'),
      },
      '& .MuiFormLabel-root.Mui-focused:not(.Mui-Error)': {
        color: theme.get('palette.pause.primary.main'),
        backgroundColor: theme.get('palette.pause.background.dark'),
      },
      '& .MuiFilledInput-input': {
        padding: '27px 12px 10px', // TODO - remove this override and investigate where the padding: 0 is coming from
      },
    })}
    variant="filled"
  >
    <InputLabel id={id}>{label}</InputLabel>
    <Select
      labelId={id}
      variant="filled"
      color="primary"
      IconComponent={ChevronDown}
      {...props}
    >
      {options.map((option) => (
        <PauseMenuItem
          key={option.value}
          css={(theme) => ({
            color: theme.get('palette.pause.primary.medium'),
          })}
          value={option.value}
        >
          <PauseTypography variant="body1">{option.label}</PauseTypography>
        </PauseMenuItem>
      ))}
    </Select>
  </FormControl>
);

PauseSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    // label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  formControlProps: PropTypes.shape(),
};

PauseSelect.defaultProps = {
  formControlProps: {},
};
